import { Props_SnippetContent } from './Content.props'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'

const SnippetContent = (props: Props_SnippetContent) => {
    const { heading, repeatable_link, paragraph, linkProps } = props
    
    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-content__heading--${heading.visibility.value}` : ''
    const classHeadingAlignment: string = heading.alignment?.value ? `snippet-content__heading--alignment-${heading.alignment.value}` : ''
    const textalignmentClass: string = paragraph.alignment?.value ? `snippet-content__content--alignment-${paragraph.alignment.value}` : ''
    const linkAlignmentClass: string = linkProps.alignment?.value ? `snippet-content__link-container--${linkProps.alignment.value}` : ''

    return (
        <section className="snippet-content">
            <div className="snippet-content__container">
                <h2 className={`snippet-content__heading ${classHeadingVisibility} ${classHeadingAlignment}`}>{heading?.content?.value}</h2>
                <div className={`snippet-content__content ${textalignmentClass}`}>
                    {paragraph.text.value && Legacy_CompileMarkdown(paragraph?.text?.value)}
                </div>
                   <div className={`snippet-content__link-container ${linkAlignmentClass}`}>
                       {repeatable_link.map((link, index) => {
                           const linkTarget = link?.linkTarget?.value === "true" ? '_blank' : undefined;
                           const linkText = link?.linkText?.value;
                           const linkHref = link?.linkHref?.value;
                           const linkStyle = link?.linkStyle?.value;

                           return (
                               <SnippetLink
                                   key={`link-${linkHref} ${index}`}
                                   linkStyles={linkStyle}
                                   className="snippet-content__link"
                                   url={linkHref}
                                   openInNewTab={linkTarget === "_blank"}
                                   rel={linkTarget === '_blank' ? 'noopener noreferrer' : undefined}
                               >
                                   {linkText}
                               </SnippetLink>
                           );
                       })}
                   </div>
               
            </div>
        </section>
    )}

export default SnippetContent
